export default "__VITE_ASSET__CjtHx9At__"